export enum CloseInvoiceTab {
    CloseInvoiceManagement = 0,
    Transactions = 1,
}
